import * as types from '../mutation-types'
import req from '../../lib/authRequest'

/*
 * Vuex module to handle Hosting related data for self-signup

    Server model:
      - id
      - name
      - status
      - ip_address
      - mem
      - cpu
      - managed
 */

const state = {
  // If a request to manage hosting is currently happening
  creating_hosting: false,
  deleting_hosting: false
}

const getters = {
}

const mutations = {
    [types.CREATING_HOSTING] (state) {
        state.creating_hosting = true
    },
    [types.FINISHED_CREATING_HOSTING] (state) {
        state.creating_hosting = false
    },
    [types.DELETING_HOSTING] (state) {
        state.deleting_hosting = true
    },
    [types.FINISHED_DELETING_HOSTING] (state) {
        state.deleting_hosting = false
    },
}

const actions = {
    createHosting ({ commit }, newHosting) {
        return new Promise((resolve, reject) => {
          commit(types.CREATING_HOSTING)
          req.post({
            url: '/plesk_servers',
            data: newHosting,
            notifications: false,
            modalNotifications: true,
            success (result) {
              commit(types.FINISHED_CREATING_HOSTING)
              resolve(result)
            },
            error (result) {
              commit(types.FINISHED_CREATING_HOSTING)
              reject(result)
            }
          })
        })
      },
    deleteHosting ({ commit }, data) {
        return new Promise((resolve, reject) => {
          commit(types.DELETING_HOSTING)
          req.post({
            url: '/plesk_servers/delete',
            data: data,
            success (result) {
              commit(types.FINISHED_DELETING_HOSTING)
              resolve(result)
            },
            error (result) {
              commit(types.FINISHED_DELETING_HOSTING)
              reject(result)
            }
          })
        })
    },
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/hosting.js